import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { modalType } from '../../../actions/ui'

// components
import { Banner, AIScore, EntityScore } from '../../../components'
import { ENTITY_TYPE, QR } from '../../../utils'
import { capitalize } from 'lodash'

const { INSTITUTION } = ENTITY_TYPE

const propTypes = {
  dataIdPrefix: PropTypes.string.isRequired,
  institution: PropTypes.object.isRequired,
  targetId: PropTypes.string,
  hasActiveDeal: PropTypes.bool,
  onDealSaveSuccess: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
}

const defaultProps = {
  dataIdPrefix: 'InstitutionPage',
  institution: {},
  hasActiveDeal: false
}

/**
 * Banner Detail Component
 * @param type
 * @param style
 * @param turnover
 */
const Details = ({ type, style, turnover }) => {
  return (
    <>
      {type ? <span>{type}</span> : null}
      <span className={`${type ? 'divider' : ''}`}>Style: {style || '-'}</span>
      <span className='divider'>Turnover: {turnover ? capitalize(turnover) : '-'}</span>
    </>
  )
}

/**
 * Institution Banner Component
 * @param props
 */
function InstitutionBanner (props) {
  const { dataIdPrefix, institution, targetId, hasActiveDeal, onDealSaveSuccess, openModal } = props
  const { id, institutionName, institutionType, style, turnover, qualityRating } = institution

  const controls = [
    {
      type: 'score',
      ScoreComponent: <AIScore
        dataId={dataIdPrefix}
        entityId={id}
        entityType={INSTITUTION}
        style={style}
      />
    },
    {
      type: 'score',
      ScoreComponent: <EntityScore
        dataId={`${dataIdPrefix}QrScore`}
        data={{
          title: 'QR Score',
          score: qualityRating,
          message: QR
        }}
        openModal={openModal}
      />
    },
    {
      type: 'button',
      dataId: `${dataIdPrefix}BannerEntityUpdate`,
      label: 'Request Update',
      onClick: () => openModal({
        type: modalType.ENTITY_UPDATE_REQUEST_MODAL,
        props: {
          values: {
            entityId: id,
            entityType: INSTITUTION,
            name: institutionName
          }
        }
      })
    },
    {
      dataId: `${dataIdPrefix}BannerUtility`,
      type: 'utility',
      entity: { ...institution, _target: targetId },
      entityType: INSTITUTION,
      items: [
        { action: 'CREATE_ACTIVITY' },
        {
          action: 'TARGET',
          hide: hasActiveDeal
        },
        {
          action: 'CREATE_DEAL',
          onSaveSuccess: onDealSaveSuccess
        },
        { action: 'DOWNLOAD_TEARSHEET' },
        { action: 'BRIEFING_BOOK' }
      ]
    }
  ]

  return (
    <Banner
      size='medium'
      icon='q4i-institution-2pt'
      title={institutionName}
      details={
        <Details
          type={institutionType}
          style={style}
          turnover={turnover}
        />}
      controls={controls}
    />
  )
}

InstitutionBanner.propTypes = propTypes
InstitutionBanner.defaultProps = defaultProps

export default memo(InstitutionBanner)
